import React from 'react'
import Filter from "../Filter/Filter.jsx";



function ProductGrid(props) {

    return (
        <div>
            <Filter pageURL={props.pageURL} />
        </div>
    )
}

export default ProductGrid
